import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  doc,
  getDoc,
  updateDoc,
  addDoc,
  collection,
  serverTimestamp
} from "firebase/firestore";
import {  query, where, getDocs } from "firebase/firestore";
import { db } from "../config";

export default function CmdPlan() {
  const auth = getAuth();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [balance, setBalance] = useState(0);
  const [message, setMessage] = useState("");
  const [compoundPlan, setCompoundPlan] = useState({ amount: 0, duration: 0 });

  // Fetch user
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      if (u) {
        setUser(u);
        const userRef = doc(db, "users", u.uid);
        const snap = await getDoc(userRef);
        if (snap.exists()) {
          setBalance(snap.data().balance || 0);
        }
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, [auth]);

  // Fetch compounding plan
  useEffect(() => {
    const fetchCompoundPlan = async () => {
      const docRef = doc(db, "settings", "compoundingPlan");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        setCompoundPlan(snap.data());
      }
    };
    fetchCompoundPlan();
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!user) {
    setMessage("Please log in.");
    return;
  }

  setMessage("");
  setLoading(true);

  try {
    const form = e.target;
    const plan = "DELUXE";
    const amount = parseFloat(form.amount.value);
    const paytype = form.paytype.value;

    if (isNaN(amount) || amount < compoundPlan.amount) {
      setMessage(`Amount must be at least $${compoundPlan.amount}`);
      setLoading(false);
      return;
    }
    if (amount > balance) {
      setMessage("Insufficient balance.");
      setLoading(false);
      return;
    }

    const userDoc = await getDoc(doc(db, "users", user.uid));
    const userEmail = userDoc.data()?.email;

    const activeQuery = query(
      collection(db, "compoundInvest"),
      where("email", "==", userEmail),
      where("status", "==", "active")
    );
    const activeQuerySnapshot = await getDocs(activeQuery);

    if (!activeQuerySnapshot.empty) {
      setMessage("You already have an active compounding plan.");
      setLoading(false);
      return;
    }

    const userRef = doc(db, "users", user.uid);
    await updateDoc(userRef, {
      balance: balance - amount
    });

    await addDoc(collection(db, "compoundInvest"), {
      userId: user.uid,
      email: user.email,
      plan,
      amount,
      paytype,
      durationDays: compoundPlan.duration,
      status: "active",
      startAt: serverTimestamp(),
      // endAt: new Date(Date.now() + compoundPlan.duration * 864e5)
    });

    setBalance((prev) => prev - amount);
    setMessage("✅ Investment activated successfully!");
    form.reset();
  } catch (err) {
    console.error(err);
    setMessage("❌ Error processing investment, please try again.");
  } finally {
    setLoading(false);
  }
};



  return (
    <div className="page">
      <Helmet>
        <script src="forthfunded/popper.min.js" />
        <script src="forthfunded/bootstrap.bundle.min.js" />
        <script src="forthfunded/defaultmenu.min.js" />
        <script src="forthfunded/waves.min.js" />
        <script src="forthfunded/sticky.js" />
        <script src="forthfunded/simplebar.min.js" />
        <script src="forthfunded/simplebar.js" />
        <script src="forthfunded/pickr.es5.min.js" />
        <script src="forthfunded/apexcharts.min.js" />
        <script src="forthfunded/crypto-dashboard.js" />
        <script src="forthfunded/custom-switcher.min.js" />
        <script src="forthfunded/custom.js" />
          </Helmet>
    
   <Header />
        <Nav />
        {/* <SeedPlans/> */}

      <div className="main-content app-content">
        <div className="container-fluid py-4">
          <h2 className="text-center mb-4">Compounding Packages</h2>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card shadow-lg border border-success">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <div className="fs-18 fw-semibold">Deluxe</div>
                      <div>
                        <span className="badge bg-success">
                          DELUXE COMPOUNDING
                        </span>
                      </div>
                    </div>
                    <div className="text-end">
                      <div className="fs-25 fw-bold mb-1">
                        ${compoundPlan.amount}
                        <sub className="text-muted fw-semibold fs-11 ms-1">
                          / Starting
                        </sub>
                      </div>
                      <div className="mb-1 text-muted">
                        This Compounding plan returns automatically on
                        maturity.
                      </div>
                      <div className="fs-12 mb-3 text-dark">
                        <u>Daily/Weekly variable ROI in {compoundPlan.duration} days</u>
                      </div>
                    </div>
                  </div>

                  <p>
                    <strong>Available Balance:</strong> ${balance.toFixed(2)}
                  </p>
                  {message && <div className="alert alert-info">{message}</div>}

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Amount ($)</label>
                      <input
                        type="number"
                        name="amount"
                        className="form-control"
                        placeholder={`Enter amount ≥ $${compoundPlan.amount}`}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Payment Type</label>
                      <select name="paytype" className="form-select" required>
                        <option value="USDT">Account Balance</option>
                        <option value="BTC">Bitcoin</option>
                        <option value="ETH">Ethereum</option>
                      </select>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={loading}
                    >
                      {loading ? "Processing..." : "Compound Now"}
                    </button>
                  </form>
                </div>
              </div>

              <div className="text-center text-muted mt-3">
                Contact support for inquiries.
              </div>
            </div>
          </div>
        </div>

        <footer className="footer mt-auto py-3 bg-white text-center">
          <span className="text-muted">© 2025 FarYieldFi</span>
        </footer>
      </div>
    </div>
  );
}

// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet";
// import Header from "../Components/Header";
// import Nav from "../Components/Nav";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import {
//   doc,
//   getDoc,
//   updateDoc,
//   addDoc,
//   collection,
//   serverTimestamp
// } from "firebase/firestore";
// import { db } from "../config";

// export default function CmdPlan() {
//   const auth = getAuth();
//   const [loading, setLoading] = useState(false);
//   const [user, setUser] = useState(null);
//   const [balance, setBalance] = useState(0);
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (u) => {
//       if (u) {
//         setUser(u);
//         const userRef = doc(db, "users", u.uid);
//         const snap = await getDoc(userRef);
//         if (snap.exists()) {
//           setBalance(snap.data().balance || 0);
//         }
//       } else {
//         setUser(null);
//       }
//     });
//     return () => unsubscribe();
//   }, [auth]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!user) {
//       setMessage("Please log in.");
//       return;
//     }

//     setMessage("");
//     setLoading(true);

//     try {
//       const form = e.target;
//       const plan = form.plan.value;
//       const min = parseFloat(form.min.value);
//       const durationDays = parseInt(form.duration.value, 10);
//       const amount = parseFloat(form.amount.value);
//       const paytype = form.paytype.value;

//       if (isNaN(amount) || amount < min) {
//         setMessage(`Amount must be at least $${min}`);
//         setLoading(false);
//         return;
//       }
//       if (amount > balance) {
//         setMessage("Insufficient balance.");
//         setLoading(false);
//         return;
//       }

//       const userRef = doc(db, "users", user.uid);
//       await updateDoc(userRef, {
//         balance: balance - amount
//       });

//       await addDoc(collection(db, "compoundInvest"), {
//         userId: user.uid,
//         email: user.email,
//         plan,
//         amount,
//         paytype,
//         durationDays,
//         status: "active",
//         startAt: serverTimestamp(),
//         endAt: new Date(Date.now() + durationDays * 864e5)
//       });

//       setBalance((prev) => prev - amount);
//       setMessage("✅ Investment activated successfully!");
//       form.reset();
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Error processing investment, please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="page">
//       <Helmet>
//         <link
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
//           rel="stylesheet"
//         />
//         <script src="https://forthfunded.com/assets/libs/@popperjs/core/umd/popper.min.js" />
//         <script src="https://forthfunded.com/assets/libs/bootstrap/js/bootstrap.bundle.min.js" />
//         <script src="https://forthfunded.com/assets/js/defaultmenu.min.js" />
//         <script src="https://forthfunded.com/assets/libs/node-waves/waves.min.js" />
//         <script src="https://forthfunded.com/assets/js/sticky.js" />
//         <script src="https://forthfunded.com/assets/libs/simplebar/simplebar.min.js" />
//         <script src="https://forthfunded.com/assets/js/simplebar.js" />
//         <script src="https://forthfunded.com/assets/libs/@simonwep/pickr/pickr.es5.min.js" />
//         <script src="https://forthfunded.com/assets/libs/apexcharts/apexcharts.min.js" />
//         <script src="https://forthfunded.com/assets/js/crypto-dashboard.js" />
//         <script src="https://forthfunded.com/assets/js/custom-switcher.min.js" />
//         <script src="https://forthfunded.com/assets/js/custom.js" />
//       </Helmet>

//       <Header />
//       <Nav />

//       <div className="main-content app-content">
//         <div className="container-fluid py-4">
//           <h2 className="text-center mb-4">Compounding Packages</h2>
//           <div className="row justify-content-center">
//             <div className="col-md-8">
//               <div className="card shadow-lg border border-success">
//                 <div className="card-body">
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <div>
//                       <div className="fs-18 fw-semibold">Deluxe</div>
//                       <div>
//                         <span className="badge bg-success">
//                           DELUXE COMPOUNDING
//                         </span>
//                       </div>
//                     </div>
//                     <div className="text-end">
//                       <div className="fs-25 fw-bold mb-1">
//                         $6,000
//                         <sub className="text-muted fw-semibold fs-11 ms-1">
//                           / Starting
//                         </sub>
//                       </div>
//                       <div className="mb-1 text-muted">
//                         This Compounding plan returns automatically on
//                         maturity.
//                       </div>
//                       <div className="fs-12 mb-3 text-dark">
//                         <u>Daily/Weekly variable ROI in 4 months</u>
//                       </div>
//                     </div>
//                   </div>

//                   <p>
//                     <strong>Available Balance:</strong> ${balance.toFixed(2)}
//                   </p>
//                   {message && <div className="alert alert-info">{message}</div>}

//                   <form onSubmit={handleSubmit}>
//                     <input type="hidden" name="plan" defaultValue="DELUXE" />
//                     <input type="hidden" name="min" defaultValue="6000" />
//                     <input type="hidden" name="duration" defaultValue="182" />

//                     <div className="mb-3">
//                       <label className="form-label">Amount ($)</label>
//                       <input
//                         type="number"
//                         name="amount"
//                         className="form-control"
//                         placeholder="Enter amount ≥ $6,000"
//                         required
//                       />
//                     </div>

//                     <div className="mb-3">
//                       <label className="form-label">Payment Type</label>
//                       <select name="paytype" className="form-select" required>
//                         <option value="USDT">Account Balance</option>
//                         <option value="BTC">Bitcoin</option>
//                         <option value="ETH">Ethereum</option>
//                       </select>
//                     </div>

//                     <button
//                       type="submit"
//                       className="btn btn-primary w-100"
//                       disabled={loading}
//                     >
//                       {loading ? "Processing..." : "Compound Now"}
//                     </button>
//                   </form>
//                 </div>
//               </div>

//               <div className="text-center text-muted mt-3">
//                 Contact support for inquiries.
//               </div>
//             </div>
//           </div>
//         </div>

//         <footer className="footer mt-auto py-3 bg-white text-center">
//           <span className="text-muted">© 2025 FarYieldFi</span>
//         </footer>
//       </div>
//     </div>
//   );
// }
